import React, { Component, Fragment } from 'react';
import { saveItemTransaction } from './bulkTransactionService';
import moment from 'moment';
import Modal from 'react-modal'
import { _addNotification, _addNotificationError, getCEPBulkTransactionsType } from '../../../../server/util';
import ReactTable from 'react-table';
import { _delete, get } from '../../../../server/actions';
import _ from 'lodash';
import { BULK_TRANS_TYPE, date_format } from '../../../../server/constants';

const mealsData = {
    Lunch: 'Lunch Served',
    Breakfast: 'Breakfast Served',
    Snack: 'Snack Served',
    Dinner: 'Dinner Served'
};
const deleteStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)'
    }
};
class MealCountComponentV2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            servedData: {},
            data: [],
            deletePurchaseModel: false,
            deleteRec: undefined,
        }
    }
    componentDidMount = () => {
        this.bindData();
        this.getTransactions();
    }
    getDate_MenuTypeChangeData = () => {
        this.setState({
            tabIndex: 0, ttabIndex: 0, selectedRows: [],
            selection: []
        }, () => {
            this.bindData();
            this.getTransactions();
        });
    }

    bindData = () => {
        const { selectedDate, mealType, setLoading } = this.props;
        const recObj = {};
        recObj.mealId = 0;
        recObj.mealName = mealsData[mealType];
        recObj.grade = undefined
        recObj.mealType = mealType.toUpperCase();
        recObj.teacher = undefined;
        recObj.totalQty = 0;
        this.setState({ servedData: { ...recObj } });
    }
    getSystemDateTime = () => {
        const { selectedDate } = this.props;
        const selectedDateTime = moment(selectedDate).set({
            hour: moment().get('hour'),
            minute: moment().get('minute'),
            second: moment().get('second')
        })
        let _datetime = moment.utc(selectedDateTime).format('YYYY-MM-DDTH:mm:ss');
        return _datetime + 'Z';
    }
    getTransactions = () => {
        const { selectedDate } = this.props;
        let schoolId = sessionStorage.getItem('SchoolId');
        const { mealType } = this.props;
        this.setState({ loading: true });
        const sDate = moment(selectedDate).startOf('D');
        const eDate = moment(selectedDate).endOf('D')
        let url = `/cep/reports/${schoolId}/purchaseTransactions/${mealType}?startDate=${moment(sDate).utc().format("YYYY-MM-DDTHH:mm:ss")}&endDate=${moment(eDate).utc().format("YYYY-MM-DDTHH:mm:ss")}&access_token=`;

        get(url).then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
                //throw Error(response.errorMessage);
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                return res.json();
            }
        }).then(data => {
            this.setState({
                data: data.resp, loading: false
            });
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, this);
                this.setState({ loading: false })
            }
        );
    }

    saveTransaction = (e) => {
        e.preventDefault();
        const { setLoading, mealType } = this.props;
        const { servedData } = this.state;
        if (servedData.totalQty > 0) {
            const systemDateTime = this.getSystemDateTime();
            let schoolId = sessionStorage.getItem('SchoolId');
            const loginUserInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));

            const gradeObj = {
                grade: 'All',
                mealType: (mealType === 'Lunch' ? 'MEAL' : mealType).toUpperCase(),
                qty: servedData.totalQty,
                trxDate: systemDateTime,
                transactionItems: []
            };
            saveItemTransaction({
                schoolId,
                mealType,
                userId: loginUserInfo.userId,
                reqBody: [gradeObj]
            }).then((response) => {
                if (response.status === 200) {
                    setLoading(false);
                    this.setState({ data: [], servedData: {} })
                    _addNotification('Bulk transaction done successfully', this.props);
                    this.bindData();
                    this.getTransactions();
                } else if (!response.ok) {
                    throw Error(response.statusText);
                }
            }).catch(
                (error) => {
                    setLoading(false);
                    _addNotificationError('Bulk transaction failed ! Try again.', this.props);
                    console.log('Send Notification Error', error)
                }
            );
        }
    }
    deletePurchaseRec = () => {
        const { deleteRec } = this.state;
        const url = `/cep/transactions/${deleteRec.original.trxId}/${deleteRec.original.trxMenuId || 0}?access_token=`;
        _delete(url)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                } else {
                    return response.json();
                }
            }).then((response) => {
                if (response.statusCode === 200) {
                    this.setState({ loading: false, deletePurchaseModel: false })
                    _addNotification(response.statusMessage, this.props);
                    this.bindData();
                    this.getTransactions();
                } else {
                    throw Error(response.errorMessage);
                }
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    _addNotificationError(error.message, this);
                }
            );

    }

    render() {
        const { servedData, data } = this.state;
        const checkboxProps = {
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };
        return (<Fragment>
            <div className='row'>
                <div className='col-md-4'>
                    <div className="panel panel-primary">
                        <div className="panel-body">
                            <div className='row form-group' >
                                <div className='col-md-offset-2 col-md-8'>
                                    <label htmlFor="totalQty">{servedData.mealName}</label>
                                </div>
                            </div>
                            <div className='row form-group' >
                                <div className='col-md-offset-2 col-md-8'>
                                    <input type="number" className="form-control" value={servedData.totalQty || ''} id="totalQty" min={0} placeholder="0" onChange={(e) => {
                                        servedData.totalQty = e.target.valueAsNumber;
                                        this.setState({ servedData });
                                    }} />
                                </div>
                            </div>
                            <div className='row form-group' >
                                <div className='col-md-12 text-center'>
                                    <button type="button" style={{ margin: '0px' }} className="btn btn-primary btn-sm" onClick={(e) => {
                                        this.saveTransaction(e);
                                    }}>Save</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className='col-md-8'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ReactTable ref={(r) => this.deptTable = r} id={'deptTbl'}
                                filterable
                                columns={[
                                    {
                                        Header: 'Created By',
                                        accessor: 'createdBy',
                                        width: 250,
                                        filterMethod: (filter, row) => {
                                            const _row = row._original
                                            return (_row.createdBy).toLowerCase().startsWith(filter.value.toLowerCase())
                                        }
                                    }, {
                                        Header: 'Created On',
                                        id: 'createdOn',
                                        width: 150,
                                        accessor: row => {
                                            return (
                                                <div style={{ textAlign: "center" }}>
                                                    {moment(row.createdOn).isValid() ? moment(row.createdOn).format(`${date_format()} hh:mm`) : ''}
                                                </div>
                                            );
                                        }

                                    },
                                    {
                                        Header: `Total Qty`,
                                        id: 'totalQty',
                                        width: 100,
                                        filterable: false,
                                        accessor: row => {
                                            let Qty = 0;
                                            if (getCEPBulkTransactionsType() == BULK_TRANS_TYPE.MEALCOUNT) {
                                                Qty = row.totalQty;
                                            } else {
                                                Qty = row.qty;
                                            }

                                            return (
                                                <div style={{ textAlign: "center" }}>
                                                    {Qty}
                                                </div>
                                            );
                                        },
                                        Footer: (props) => {
                                            const { data } = props;
                                            const tempList = (data).map(d => d._original);
                                            if (getCEPBulkTransactionsType() == BULK_TRANS_TYPE.MEALCOUNT) {
                                                return <div style={{ textAlign: "center" }}> {_.sum(_.map(tempList, d => d.totalQty))}</div>
                                            } else {
                                                return <div style={{ textAlign: "center" }}> {_.sum(_.map(tempList, d => d.qty))}</div>
                                            }
                                        }
                                    },

                                    {
                                        Header: `Action`,
                                        id: 'action',
                                        width: 50,
                                        filterable: false,
                                        Cell: row => {
                                            return (
                                                <a title="Delete Transaction" onClick={() => {
                                                    this.setState({ deletePurchaseModel: true, deleteRec: row })
                                                }}><b><i className="fa tbl-rounded-icon fa-icon fa-trash bg-color-3" style={{ margin: '0px' }}></i></b></a>
                                            )
                                        }
                                    }
                                ]}
                                data={data}
                                defaultPageSize={10} minRows={0} className="-striped -highlight" {...checkboxProps} />

                        </div>
                    </div>

                </div>
            </div>
            <Modal
                isOpen={this.state.deletePurchaseModel}
                onRequestClose={() => this.setState({ deletePurchaseModel: false, deleteRec: undefined })}
                style={deleteStyles}
                contentLabel="Publish">
                <div className="modal-header">
                    <h4 className="modal-title modal-title-color" id="deleteLabel">Deleting a Transaction</h4>
                </div>
                <div className="modal-body">
                    <p>Are you sure you want to continue?</p>
                </div>
                <div className="text-right">
                    <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                        onClick={() => this.setState({ deletePurchaseModel: false, deleteRec: undefined })}><i
                            className="glyphicon glyphicon-remove"
                            style={{ marginRight: '0', paddingLeft: '0' }}></i> No
                    </button>
                    <button type="button" className="btn btn-success btn-xs"
                        style={{ margin: '0 0 0 5px' }} onClick={this.deletePurchaseRec}
                        id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Yes
                    </button>
                </div>
            </Modal>


        </Fragment >);
    }
}

export default MealCountComponentV2;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Transactions/bulkTransactions/mealCountComponentV2.js